module.exports = __webpack_public_path__ + "static/assets/ba5e2227458079ef42609e9cc01ef0f9.gif";